import type * as React from 'react';

function SvgBaseball2(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg height="1em" viewBox="0 0 16 16" width="1em" {...props}>
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h16v16H0z" />
        <path
          d="M13.5 0a2.503 2.503 0 011.538 4.472L3.58 13.892c.084.189.128.395.128.609 0 .401-.157.777-.44 1.061-.283.282-.66.438-1.06.438-.35 0-.682-.12-.95-.339l-.111-.1-.707-.707C.156 14.57 0 14.193 0 13.792s.157-.777.44-1.061c.432-.43 1.111-.533 1.66-.305L11.528.96a.268.268 0 01.035-.048A2.502 2.502 0 0113.5 0zM1.147 13.44a.494.494 0 000 .706l.707.708a.51.51 0 00.707 0 .496.496 0 000-.707l-.707-.707a.512.512 0 00-.707 0zm3.296-2.289L2.88 13.052l.067.067 1.901-1.563-.405-.405zM13.5 1c-.436 0-.844.184-1.129.507l-.031.042-7.259 8.826.543.543 8.827-7.258.042-.031A1.502 1.502 0 0013.5 1zM2 0c1.103 0 2 .897 2 2s-.897 2-2 2-2-.897-2-2 .897-2 2-2zm0 1c-.551 0-1 .449-1 1 0 .551.449 1 1 1 .551 0 1-.449 1-1 0-.551-.449-1-1-1z"
          fill="#00182E"
        />
      </g>
    </svg>
  );
}

export default SvgBaseball2;
